'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamRewindMessage = function CamRewindMessage(_ref) {
  var href = _ref.href;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cam-rewind-message' },
    'It\'s nighttime. Enjoy a ',
    _react2.default.createElement(
      'a',
      { href: href },
      'cam rewind'
    ),
    ' clip.'
  );
};

CamRewindMessage.propTypes = {
  href: _propTypes2.default.string.isRequired
};

CamRewindMessage.defaultProps = {
  href: _propTypes2.default.string.isRequired
};

exports.default = CamRewindMessage;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamRewindMessage/CamRewindMessage.js
// module id = 543
// module chunks = 11